import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

const TableCostSavingCalculationSettingsSkeleton = () => {
  return [...Array(4)].map(() => (
    <tr key={uuidv4()} className={style.skeletonRow}>
      <td className={style.facilityColumn}>
        <SkeletonBlock className={style.skeletonText} />
      </td>
      <td>
        <SkeletonBlock className={style.skeletonText} />
      </td>
    </tr>
  ));
};

export default TableCostSavingCalculationSettingsSkeleton;
